import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
}));

const LabelTipoPaquete = (props) => {
  const { arrayData = [] } = props;
  const classes = useStyles();
  if (arrayData[0] === null) return null;
  return (
    <div className={classes.root}>
      {arrayData.map((item, index) =>
        index < 7 ? (
          <Chip
            variant="outlined"
            color="primary"
            key={index}
            label={item.Descripcion}
          />
        ) : null
      )}
    </div>
  );
};
export default LabelTipoPaquete;
